import {addDays} from 'date-fns';
import {useTranslation} from 'react-i18next';

import {PartOfDay, getMeetingsByDate, getMeetingsLoadingStatusByDate, useAppSelector} from '@lib/store';
import {LoaderTile, Tile} from '../Tile';
import {selectMeetingsToShow, defaultSelectionOptions, describeMeeting} from '@lib/store/src/util';
import {MeetingTile} from './MeetingTile';

type Props = {
  date: Date;
  time: Date;
  partOfDay: PartOfDay;
};

export const UpcomingMeetingTile = ({date, time, partOfDay}: Props) => {
  const {t} = useTranslation();
  const meetings = useAppSelector((state) => getMeetingsByDate(state, date));
  const tomorrowMeetings = useAppSelector((state) => getMeetingsByDate(state, addDays(date, 1)));
  const meetingsLoadingStatus = useAppSelector((state) => getMeetingsLoadingStatusByDate(state, date));

  const visibleMeetings = selectMeetingsToShow([...meetings, ...tomorrowMeetings], time, {
    ...defaultSelectionOptions,
    excludeMeetingsOnDifferentDays: partOfDay === 'WorkingHours',
  });
  const upcomingMeeting = visibleMeetings[0];

  if (meetingsLoadingStatus !== 'Loaded') {
    return <LoaderTile />;
  }

  if (!upcomingMeeting) return null;

  const startTime = new Date(upcomingMeeting.startDateTime);
  const endTime = new Date(upcomingMeeting.endDateTime);
  const {countdown, isOngoing, label} = describeMeeting(time, startTime, endTime, t);

  return (
    <Tile
      title={t('meeting:UpcomingMeeting')}
      titleNote={isOngoing ? label ?? undefined : countdown ?? undefined}>
      <MeetingTile
        meeting={upcomingMeeting}
        time={time}
      />
    </Tile>
  );
};
